module.exports = __webpack_public_path__ + "img/Capture10.f86c30e8.jpg";